/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var numberList = "";
  var count = 0;

  var addmore = function addmore() {
    count++;
    var autofocus = "";
    if (count == 1) autofocus = "autofocus";
    numberList += "\n        <ul>\n          <li class=\"item-content item-input item-input-outline\">\n            <div class=\"item-inner\">\n              <div class=\"item-input-wrap input-dropdown-wrap\" style=\"width:90px\">\n                <select placeholder=\"Please choose...\" id=\"numberType" + count + "\" " + autofocus + ">\n                  <option value=\"Male\">Single</option>\n                  <option value=\"Female\">i-Box</option>\n                  <option value=\"Female\">Box</option>\n                </select>\n              </div>\n              <div class=\"item-input-wrap\" style=\"width:80px\">\n                <input type=\"number\" pattern=\"\\d*\" maxlength = \"4\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\" placeholder=\"- - - -\" name=\"" + count + "\" id=\"number1_" + count + "\" class=\"myNumber\"/>\n              </div>\n              <div class=\"item-input-wrap\" style=\"width:60px\">\n                <input type=\"number\" pattern=\"\\d*\" maxlength = \"4\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\" placeholder=\"0\" name=\"" + count + "\" id=\"number2_" + count + "\" class=\"myNumber\" disabled/>\n              </div>\n              <div class=\"item-input-wrap\" style=\"width:60px\">\n                <input type=\"number\" pattern=\"\\d*\" maxlength = \"4\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\" placeholder=\"0\" name=\"" + count + "\" id=\"number3_" + count + "\" class=\"myNumber\" disabled/>\n              </div>\n              <div class=\"item-input-wrap\" style=\"width:60px\">\n                <input type=\"number\" pattern=\"\\d*\" maxlength = \"4\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\" placeholder=\"0\" name=\"" + count + "\" id=\"number4_" + count + "\" class=\"myNumber\" disabled/>\n              </div>\n            </div>\n          </li>\n        </ul>\n  \n      ";
    $update();
  };

  var send = function send() {
    var dataframe = "D";

    for (var i = 1; i <= 8; i++) {
      if ($("#date" + i).is(':checked')) {
        dataframe += "%23" + $("#date" + i).val();
      }
    } //GD Provider 8 SG Provider 4


    dataframe += "%0D%0A" + "%23" + "8";
    if ($("#provider2").is(':checked')) dataframe += "4";

    for (var i = 1; i <= count; i++) {
      var num1 = $("#number1_" + i).val();
      var num2 = $("#number2_" + i).val();
      var num3 = $("#number3_" + i).val();
      var num4 = $("#number4_" + i).val();

      if (num1 != "") {
        if (num2 != "") dataframe += "%0D%0A" + num1 + "%23" + num2;
        if (num3 != "") dataframe += "%0D%0A" + num1 + "%23" + num3;
        if (num4 != "") dataframe += "%0D%0A" + num1 + "%23" + num4;
      }
    }

    console.log(dataframe);
    $f7.request.get('https://temp/json/bet2.aspx?user=' + localStorage.getItem("username") + '&pass=' + localStorage.getItem("password") + '&currency=MYR&bet=' + dataframe).then(function (res) {
      var raw = res.data.replace(/(\r\n|\n|\r)/gm, "");
      console.log(raw);
      var data = JSON.parse(raw);

      if (data.ALERT != undefined && data.ALERT != "") {
        $f7.dialog.alert(data.ALERT);
      }

      if (data.status == "1") {
        localStorage.setItem("receipt", raw);
        $f7.views.main.router.navigate("/receipt/", {
          reloadCurrent: true,
          force: true
        });
        /*
        $f7.dialog.alert(data.receipt,'Receipt', function () {
          $f7.views.main.router.navigate("/",{reloadCurrent:true,force:true});
        });
        */
      } else {
        $f7.dialog.alert(data.errmsg, "Error");
      }
    });
  };

  $on('pageInit', function () {
    $(document).on('keyup', '.myNumber', function (e) {
      console.log('input value changed for ' + e.srcElement.name + $('#number1_' + e.srcElement.name).val().length);
      document.getElementById("number2_" + e.srcElement.name).disabled = true;
      document.getElementById("number3_" + e.srcElement.name).disabled = true;
      document.getElementById("number4_" + e.srcElement.name).disabled = true;
      if ($('#number1_' + e.srcElement.name).val().length == 2) document.getElementById("number4_" + e.srcElement.name).disabled = false;

      if ($('#number1_' + e.srcElement.name).val().length == 3) {
        document.getElementById("number4_" + e.srcElement.name).disabled = false;
        document.getElementById("number3_" + e.srcElement.name).disabled = false;
      }

      if ($('#number1_' + e.srcElement.name).val().length == 4) {
        document.getElementById("number4_" + e.srcElement.name).disabled = false;
        document.getElementById("number3_" + e.srcElement.name).disabled = false;
        document.getElementById("number2_" + e.srcElement.name).disabled = false;
      }
    });
    var d = new Date();
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    for (var i = 1; i <= 8; i++) {
      $(".date" + i).html(d.getDate() + " " + months[d.getMonth()]);
      $().name;
      $("#date" + i).val(("0" + (d.getMonth() + 1)).slice(-2) + "" + ("0" + d.getDate()).slice(-2));
      console.log($("#date" + i).val());
      d.setDate(d.getDate() + 1);
    }

    for (var i = 0; i < 5; i++) {
      addmore();
    }
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="about">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">
              <span class='en'>Back</span>
              <span class='cn'>返回</span>
              <span class='tl'>Fila</span>
            </span>
          </a>
        </div>
        <div class="title">
          <img src="static/images/gd.png" width="30px" style="vertical-align:middle"/>
          <span style="margin-left:10px;">GD Lotto 4D,3D,2D</span>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div class="block">
        Please fill in the form below to submit your betting. Good Luck.
      </div>
    
      <div class=block>

  
        <div class="row">
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="date1" checked/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="date1" class="date1">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="date2"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="date2" class="date2">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="date3"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="date3" class="date3">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="date4"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="date4" class="date4">d MM</label>
            </label>
          </div>
        </div>
  
        <br/>
        <div class="row">
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="date5"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="date5" class="date5">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="date6"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="date6" class="date6">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="date7"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="date7" class="date7">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="date8"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="date8" class="date8">d MM</label>
            </label>
          </div>
        </div>
      </div>
  
      
  
  
      <div class="block">
      <table class="block" width=100% style="background-color:var(--f7-theme-color);border-top-left-radius: 10px;border-top-right-radius: 10px;font-size: 16px;font-weight: 700;height: 32px;">
      
        <td width="25%">
          TYPE
        </td>
        <td width="27%">
          NUMBER
        </td>
        <td width="16%">
          4D
        </td>
        <td width="18%">
          3D
        </td>
        <td >
          2D
        </td>
      </table>
      </div>
  
      <div class="block list inline-labels no-hairlines-md" style="margin-top: -35px;" innerHTML=${numberList}>
  
      </div>
  
      <div class="block">
        <div style="margin-top:-35px;background-color:var(--f7-theme-color);border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;font-size: 16px;font-weight: 700;height: 10px;">
  
        </div>
      </div>
  

      <div class="list simple-list" style="margin-left:90px; margin-right:-15px; background-color: black;margin-top: -30px;">
        <ul style="border-radius: 20px; background-color: black;">
          <li class="item-content item-input item-input-outline">
            <div class="item-media">
              <i class="icon demo-list-icon"></i>
            </div>
            <div class="item-inner">
              <div class="item-title item-floating-label">Phone Number</div>
              <div class="item-input-wrap">
                <input type="text" placeholder="Buyer phone number" />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
        </ul>
      </div>  

      <div class="list simple-list" style="width: 120px; background-color: black;margin-top: -60px;">
        <ul style="border-radius: 20px; background-color: black;">
          <li style="height: 30px;">
            <img src="static/images/sg.png" width=30px/>
            <label class="toggle">
              <input type="checkbox" id="provider2"/>
              <span class="toggle-icon"></span>
            </label>
          </li>
        </ul>
      </div>

    
      <p class="segmented block" style="margin-top: -20px;">
        <button class="button" ></button>
        <button class="button" @click=${addmore}>Add More</button>
        <button class="button button-fill button-active" @click=${send}>Submit</button>
        <span class="segmented-highlight"></span>
      </p>
  
  
  
    
  
  
      
  
    </div>
  </div>
  `
    }
    ;
}

framework7Component.id = '9d90144362';
export default framework7Component;